import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CancelButton from '../cancelButton';
import ButtonOk from '../../buttonOk';
import { Grid } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 595,
  bgcolor: '#F1F6FF',
  boder:1,
  borderRadius: 3,
  p: 4,
};

export default function PrintPdfWarning({ open, handleClose,handlePDFEmit,...props }) {
//   const [open, setOpen] = React.useState(true);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        >
        <Box sx={style}>
          <Typography sx={{color:"#4B4B4B"}}  >
            O arquivo para impressão pode demorar além do normal para ser gerado devido à quantidade de dados a serem impressos. Deseja continuar?
          </Typography>
          <Grid sx={{display:"flex",justifyContent:"center",gap:"15px",marginTop:"20px"}}>
          <CancelButton onClick={handleClose}>
          </CancelButton>
          <ButtonOk onClick={handlePDFEmit} >
            Continuar
          </ButtonOk>
          </Grid>
        </Box>
        
      </Modal>
    </div>
  );
}